import { View } from 'lucide-react';

import { ReviewRequestTerminationDialog, ReviewRequestTerminationTooltip } from 'src/containers/SaasEscrow/Termination';
import { useSaasEscrow } from 'src/context/saas-escrow';
import { Button } from '@/components/ui/button';

const ReviewRequestTermination = () => {
  const {
    saasEscrow: { escrowTermination },
  } = useSaasEscrow();

  if (escrowTermination?.policy.accept)
    return (
      <ReviewRequestTerminationDialog
        triggerNode={
          <Button>
            <View />
            Review request
          </Button>
        }
      />
    );

  return (
    <ReviewRequestTerminationTooltip
      triggerNode={
        <div>
          <Button disabled>
            <View />
            Review request
          </Button>
        </div>
      }
    />
  );
};

export default ReviewRequestTermination;
